import { GridUtilsV2 } from '@schenck/rotec-components';
import { GridConfig } from '../models/grid-config.model';
import { UserGridKeys, UserRole } from '../enums/user.enum';

export const USER_GRID_CONFIG_DEFAULT: GridConfig = {
  pageSize: 15,
  displayedColumns: [
    UserGridKeys.Email,
    UserGridKeys.Surname,
    UserGridKeys.GivenName,
    UserGridKeys.Role,
    UserGridKeys.Actions,
  ],
  columnOrder: [
    UserGridKeys.Email,
    UserGridKeys.GivenName,
    UserGridKeys.Surname,
    UserGridKeys.Role,
    UserGridKeys.Actions,
  ],
  columnsWidths: {
    [UserGridKeys.Email]: '25%',
    [UserGridKeys.GivenName]: '24%',
    [UserGridKeys.Surname]: '20%',
    [UserGridKeys.Role]: '20%',
    [UserGridKeys.Actions]: '10%',
  },
};

export const USER_GRID_DEFAULT_FILTERS = {
  [UserGridKeys.Email]: GridUtilsV2.multiselectFilter,
  [UserGridKeys.GivenName]: GridUtilsV2.multiselectFilter,
  [UserGridKeys.Surname]: GridUtilsV2.multiselectFilter,
  [UserGridKeys.Role]: GridUtilsV2.checkboxFilter,
};

export const USER_GRID_STORAGE_KEY = 'UserGridConfig';

export const USER_ROLES = [UserRole.Admin, UserRole.Operator, UserRole.Supervisor, UserRole.RoTec];
